import { DesignPencil } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { Notes, PageHeader } from "shared/components";
import { Flex } from "styled-system/jsx";
import { useCustomListDetailsContext } from "../../CustomListDetailsContext";
import { EnumEntityReferenceType } from "gql/generated";
import { Dispatch, SetStateAction, useState } from "react";

export const ListNotes = () => {
  const { t } = useTranslation();
  const { list } = useCustomListDetailsContext();

  const [noteCreatingState, setCreatingState] = useState<{
    isCreatingNote: boolean;
    setIsCreatingNote: Dispatch<SetStateAction<boolean>>;
  }>();

  return (
    <Flex flexDir={"column"} gap={"400"}>
      <PageHeader
        title={t("customLists:LIST_DETAILS.TABS.LIST_NOTES")}
        Icon={DesignPencil}
        ctaButtonCopy={t("customLists:LIST_DETAILS.CTA_BUTTONS.NEW_NOTE")}
        ctaButtonProps={{
          onClick: () => noteCreatingState?.setIsCreatingNote(true),
          disabled: noteCreatingState?.isCreatingNote,
        }}
      />
      <Notes
        _entityId={list._id}
        type={EnumEntityReferenceType.List}
        getNoteCreatingState={setCreatingState}
      />
    </Flex>
  );
};
